import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import "./Summary.css";
import { bounceIn, fadeIn, fadeInUp, fadeInRight, lightSpeedIn, fadeInLeft } from 'react-animations';
import { StyleRoot, keyframes } from 'radium';
import { useTranslation } from "react-i18next";
import { Helmet } from 'react-helmet-async';
import ReactGA from 'react-ga4';
import { Elements } from "@stripe/react-stripe-js"
import { loadStripe } from "@stripe/stripe-js"
import PaymentForm from "../../components/PaymentForm/PaymentForm"
import axios from "axios";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination } from 'swiper/modules';
import StarIcon from '@material-ui/icons/Star';
import StarHalfIcon from '@material-ui/icons/StarHalf';
import { format } from 'date-fns';
import { enUS, es, de,  srLatn } from 'date-fns/locale';
import { Typography, Accordion, AccordionSummary, AccordionDetails, Button} from "@material-ui/core";

const Summary = ({ lng }) => {
    const history = useHistory();
    const { t, i18n } = useTranslation();
    const [stripePromise, setStripePromise] = useState(null);
    const [clientSecret, setClientSecret] = useState("");
    const [customerName, setCustomerName] = useState("");
    const [customerEmail, setCustomerEmail] = useState("");
    const [price, setPrice] = useState("");
    const [oldPrice, setOldPrice] = useState("");
    const [formattedDate, setFormattedDate] = useState('');
    
    const [resultTitle, setResultTitle] = useState("");
    const [showCoupon, setShowCoupon] = useState(false);

    const axiosInstance = axios.create({
        baseURL: process.env.REACT_APP_API_URL
      })

    const [isGeneratingCoupon, setIsGeneratingCoupon] = useState(false);
    const [couponExpiryDate, setCouponExpiryDate] = useState("");
    
    useEffect(() => {
        const hasGenerated = localStorage.getItem("turboCouponGenerated");
        let expiry = localStorage.getItem("turboCouponExpiry");
    
        if (!hasGenerated) {
            setIsGeneratingCoupon(true);
            
            const d = new Date();
            d.setHours(d.getHours() + 96);
            expiry = d.toISOString();
            localStorage.setItem("turboCouponExpiry", expiry);
    
            setTimeout(() => {
                setIsGeneratingCoupon(false);
                localStorage.setItem("turboCouponGenerated", "true");
            }, 10000); 
        }
    
        if (expiry) {
            const dateObj = new Date(expiry);
            const formattedDate = dateObj.toLocaleDateString(undefined, {
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
            setCouponExpiryDate(formattedDate);
        }
    }, []);

    useEffect( async () => {
        let testId = localStorage.getItem("testId");

        if (!testId) {
            const searchParams = new URLSearchParams(window.location.search);
            const urlTestId = searchParams.get("testId");

            if (urlTestId && urlTestId.endsWith("44")) {

                let params = {
                    id: urlTestId,
                  };
            
                const { data } = await axiosInstance.post("api/summary-result", params);
               

                const realTestId = urlTestId.slice(0, -2);
                
                localStorage.setItem("resultTitle", data.conclusionFree);
                localStorage.setItem("resultLevel", data.resultLevel);
                localStorage.setItem("customerEmail", '"'+data.email+'"');
                localStorage.setItem("customerName", '"'+data.name+'"');
                if(data.lng) {
                    i18n.changeLanguage(data.lng);
                }
                if (data.createdAt) {
                    const createdDate = new Date(data.createdAt);
                    createdDate.setHours(createdDate.getHours() + 96);
                    localStorage.setItem("turboCouponExpiry", createdDate.toISOString());
                }
                setCustomerName(data.name);
                setCustomerEmail(data.email)
        
                localStorage.setItem("testId", realTestId);
                testId = realTestId;


                const hasGenerated = localStorage.getItem("turboCouponGenerated");
                let expiry = localStorage.getItem("turboCouponExpiry");
            
            
                if (expiry) {
                    const dateObj = new Date(expiry);
                    
                    const formattedDate = dateObj.toLocaleDateString(undefined, {
                        month: 'short',
                        day: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit'
                    });
                    setCouponExpiryDate(formattedDate);
                }
            }
        }

        if (testId) {
            const response  = await axiosInstance.get("api/config");
            setStripePromise(loadStripe(response.data.publishableKey));
        }

        const storedTitle = localStorage.getItem("resultTitle");
        const storedLevel = localStorage.getItem("resultLevel");
        
        if (storedTitle) {
            setResultTitle(storedTitle);
        }

        if (storedLevel && !storedLevel.includes("B3")) {
            setShowCoupon(true);
        }

        let localeDate = enUS;
        if (i18n.language === "es") {
            localeDate = es;
        }
        if (i18n.language === "de") {
            localeDate = de;
        }
        if (i18n.language === "sr") {
            localeDate = srLatn;
        }

        let discountTime = localStorage.getItem("discount-time");
        let formatted = "";
        if (discountTime) {
            const futureDate = new Date(parseInt(discountTime));
            const currentDateTime = new Date();
            const currentDateTimeStamp = currentDateTime.getTime();
            if (parseInt(discountTime) < currentDateTimeStamp) {
                const futureDateTime = new Date(currentDateTime.setDate(currentDateTime.getDate() + 1));
                formatted = format(futureDateTime, 'MMMM do', { locale: localeDate });    
            } else {
                formatted = format(futureDate, 'MMMM do', { locale: localeDate });    
            }
        } else {
            const currentDate = new Date();
            const futureDate = new Date(currentDate.setDate(currentDate.getDate() + 3));
            localStorage.setItem('discount-time', JSON.stringify(futureDate.getTime()));
            formatted = format(futureDate, 'MMMM do', { locale: localeDate });    
        }
       
        setFormattedDate(formatted);
    }, []);
    
    useEffect( async () => {
        let testId = localStorage.getItem("testId");
        if (!testId) {
            const searchParams = new URLSearchParams(window.location.search);
            const urlTestId = searchParams.get("testId");

            if (urlTestId && urlTestId.endsWith("44")) {
                const realTestId = urlTestId.slice(0, -2);
                testId = realTestId;
            }
        }
        if (testId) {
            const response = await axiosInstance.post("api/create-payment-intent", {
                testId: testId
            });
    
            setClientSecret(response.data.clientSecret);
            setPrice(response.data.price);
            setOldPrice(response.data.oldPrice)
        }
    }, []);


    useEffect(() => {
        ReactGA.send({ hitType: "pageview", page: window.location.pathname});
        let name = JSON.parse(localStorage.getItem("customerName"));
        setCustomerName(name);

        let email = JSON.parse(localStorage.getItem("customerEmail"));
        setCustomerEmail(email)
    }, []);

    const styles = {
        bounceIn: {
          animation: 'x 3s',
          animationName: keyframes(bounceIn, 'bounceIn'),
          animationDelay: '0.1s',
          animationFillMode: 'forwards',
          opacity: 0
        },
        fadeIn: {
          animation: 'x 1.5s',
          animationName: keyframes(fadeIn, 'fadeIn'),
          animationDelay: '0.5s',
          animationFillMode: 'forwards',
          opacity: 0
        },
        fadeInUp: {
            animation: 'x 1s',
            animationName: keyframes(fadeInUp, 'fadeInUp'),
            animationDelay: '0.8s',
            animationFillMode: 'forwards',
            opacity: 0
        },
        pulse: {
            animation: 'x 1.5s',
            animationName: keyframes(fadeIn, 'fadeIn'),
            animationDelay: '1.5s',
            animationFillMode: 'forwards',
            opacity: 0
        }
    };

    const formatDynamicDate = (isoString, lang) => {
        if (!isoString) return "";
        
        const dateObj = new Date(isoString);
        
        const locales = {
            en: 'en-US',
            es: 'es-ES',
            de: 'de-DE',
            sr: 'en-US'
        };
    
        const userLocale = locales[lang] || 'en-US';
    
        return dateObj.toLocaleString(userLocale, {
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: '2-digit'
        });
    };

    const getStripeLocale = (currentLang) => {
        const localeMap = {
            en: "en",
            es: "es",
            de: "de",
            fr: "fr",
            pt: "pt", // Stripe podržava i 'pt' (Portuguese) i 'pt-BR' (Brazilian Portuguese)
            it: "it",
            pl: "pl",
            tr: "tr",
            sr: "en"  // Pošto Stripe nema 'sr', padamo na engleski (ili stavi "auto")
        };
        
        // Ako jezik iz nekog razloga nije u mapi, neka fallback bude "auto"
        return localeMap[currentLang] || "auto";
    };

    return (
            <div>
                <Helmet>
                    <title>{t("Your Result & Full Report")}</title>
                    <link rel="canonical" href={lng !== "en" ? `https://iscodingforyou.com/${lng}/summary/` : `https://iscodingforyou.com/summary/`} />
                    <meta name="description" content="See your coding potential result and unlock the full personalized report."/>
                    <meta name="robots" content="noindex"/>
                </Helmet>
                
                <div className="summary-content">
                    <StyleRoot>
    
                    {/* ===== FREE ZONE (TEASER UMESTO GOTOVOG ODGOVORA) ===== */}
                    <div className="free-zone">
                        <div className="summary-header">
                            <h1 className="summry-text" style={styles.bounceIn}>{t("Well done")}{", "} <span className="customer-name">{customerName}</span>!</h1>
                            <p className="summry-subtitle">{t("Your data has been processed successfully.")}</p>
                            
                            <div className="result-reveal-box" style={styles.bounceIn}>
                                <span className="result-label">{t("INITIAL ANALYSIS:")}</span>
                                <h2 className="result-title" style={{ fontSize: "24px", lineHeight: "1.4" }}>
                                    {t("You have demonstrated a strong foundation in logical thinking. However, our system identified a specific area you need to focus on before entering the IT industry.")}
                                </h2>
                            </div>
                        </div>
                    </div>
                    {/* ===== END FREE ZONE ===== */}
    
                    {/* ===== SECTION DIVIDER ===== */}
                    <div style={styles.pulse} className="section-divider">
                        <div className="section-divider-line"></div>
                        <div className="section-divider-content">
                            <p className="scroll-text">{t("Unlock your Full Career Report below")}</p>
                            <img src="/down1.png" className="arrow-down-img" alt="down"/>
                        </div>
                        <div className="section-divider-line"></div>
                    </div>
                    {/* ===== END SECTION DIVIDER ===== */}
    
                    {/* ===== PREMIUM ZONE ===== */}
                    <div className="premium-zone">
                        <div className="premium-zone-top-bar">
                            <span className="premium-zone-label">⭐ {t("Full Report & VIP Bonus")}</span>
                        </div>

                        {/* === DODATA SLIKA ZAKLJUČANOG IZVEŠTAJA === */}

                        {lng === "en" && (
                            <div className="locked-report-mockup" style={styles.fadeInUp}>
                                <img 
                                    src="/test223.webp"
                                    alt="Locked Premium Report" 
                                    className="mockup-img"
                                />
                            </div>
                            )}
                        {/* ======================================== */}
    
                        <div className="payment-section">
                            <div className="summary-list-wrap summary-list-wrap-1" style={styles.fadeIn}>
                                <div className="report-header">
                                    <p className="what-you-get">{t("Get Your Full Report")}</p>
                                    <p className="what-you-get-sub">{t("Discover your exact career path and claim your 80% VIP discount.")}</p>
                                </div>
                                
                                <ul className="summary-list">
                                    <li>
                                        <div className="summary-list-item-wrap">
                                            <p className="summary-list-item">{t("Test Result:")}</p>
                                            <p className="summary-list-item-2">{t("Instantly see the exact score of your test to understand your current level.")}</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="summary-list-item-wrap">
                                            <p className="summary-list-item">{t("Personalized Report:")}</p>
                                            <p className="summary-list-item-2">{t("A detailed report highlighting your strengths and areas for improvement.")}</p>
                                        </div>
                                    </li>   
                                    <li>
                                        <div className="summary-list-item-wrap">
                                            <p className="summary-list-item">{t("Career Recommendation:")}</p>
                                            <p className="summary-list-item-2">{t("Find out if you are destined for Frontend, Backend, Full-Stack, or QA Testing.")}</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="summary-list-item-wrap">
                                            <p className="summary-list-item">{t("Personalized Learning Guide:")}</p>
                                            <p className="summary-list-item-2">{t("Step-by-step roadmap tailored to your specific profile, saving you time and money.")}</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="summary-list-item-wrap">
                                            <p className="summary-list-item">{t("Recommended course:")}</p>
                                            <p className="summary-list-item-2">{t("The ultimate AI-powered course that matches your learning style.")}</p>
                                            <div className="course-discount-strip">
                                                <span className="course-discount-pct">80%</span>
                                                <span className="course-discount-desc">{t("exclusive VIP discount included")}</span>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
    
                            <div className="summary-list-wrap summary-list-wrap-2" style={styles.fadeIn}>
                                <div className="summary-price-wrap">
                                    <div className="discount-section-2"> 
                                        <div className="all-inclusive-wrap">
                                            <p className={`all-inclusive all-inclusive-${lng}`}>{t("Full Report")}</p>
                                            <p className={`all-inclusive all-inclusive-${lng}`}>{t("One-time Access")}</p>
                                        </div>
                                        {price && (
                                            <div className="price-wrap-parent"> 
                                                <span className="old-price">${oldPrice}</span> 
                                                <div className="price-wrap">
                                                    <span className="price">${price}</span> <span className="price-point">.99</span>
                                                </div>
                                            </div>
                                        )}
                                    </div>
    
                                    {couponExpiryDate ? (
                                        <p className="discount-label-time">
                                            {t("Offer valid until")} <span style={{ fontWeight: "bold" }}>{formatDynamicDate(couponExpiryDate, i18n.language)}</span>
                                        </p>
                                    ) : (
                                        <p className="discount-label-time">{t("Offer valid for limited time")}</p>
                                    )}
                                </div>
                            </div>
    
                            <div className="action-label-wrap">
                                <p className="action-label bold-text">{t("Invest in your future today.")}</p>
                            </div>
    
                            {clientSecret && stripePromise && (
                                <div className="payment-form">
                                    <p className="payment-details">{t("Secure Payment")}</p>
                                    <Elements stripe={stripePromise} options={{ clientSecret, locale: getStripeLocale(i18n.language) }}>
                                        <PaymentForm
                                            lng={lng}
                                            customerName={customerName}
                                            customerEmail={customerEmail}
                                        />
                                    </Elements>
                                </div>
                            )}
    
                            {/* ===== DOWNSELL LINK (ZA ONE KOJI NE ZELE DA PLATE) ===== */}
                            <div className="downsell-wrap">
                                <a href="https://turbocodingcourse.com" className="downsell-link">
                                    {t("I don't need the report, I just want to check out the Turbo Coding Course")} &rarr;
                                </a>
                            </div>
    
                        </div>
                    </div>
                    {/* ===== END PREMIUM ZONE ===== */}
    
                    </StyleRoot>
    
                    <div className="summary-cards">
                        <div className="summary-card">
                            <img src="/secure.svg" className="" alt="Safe and Secure"/>
                            <p><strong>{t("Safe and Secure")}</strong></p>
                            <p className="summary-card-text">{t("We ensure the security of your information.")}</p>
                        </div>
    
                        <div className="summary-card">
                            <img src="/payment-card.svg" className="" alt="One Time Payment"/>
                            <p><strong>{t("One Time Payment")}</strong></p>
                            <p className="summary-card-text">{t("No hidden fees or subscriptions.")}</p>
                        </div>
                    </div>
    
                    <div className="customers-wrap customers-wrap-2">
                        <h3 className="customers-title">
                            {t("Success Stories")}
                        </h3>
    
                        <Swiper
                        slidesPerView={1}
                        spaceBetween={30}
                        pagination={{ clickable: true }}
                        modules={[Pagination]}
                        className="mySwiper"
                        breakpoints={{
                        426: { slidesPerView: 2 },
                        769: { slidesPerView: 3 }
                        }}
                    >
                       <SwiperSlide>
                            <div className="customers-review">
                                <p className="customers-review-name">Carl H.</p>
                                <div className="customers-stars">
                                    <StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/>
                                </div>
                                <p className="customers-review-text">"{t("The report gave me a clear picture of my potential and the steps to take.")}"</p>
                            </div>
                        </SwiperSlide>
                        
                        <SwiperSlide>
                            <div className="customers-review">
                                <p className="customers-review-name">Sarah W.</p>
                                <div className="customers-stars">
                                    <StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/>
                                </div>
                                <p className="customers-review-text">"{t("The career roadmap was exactly what I needed to start.")}"</p>
                            </div>
                        </SwiperSlide>

                        <SwiperSlide>
                            <div className="customers-review">
                                <p className="customers-review-name">Carlos M.</p>
                                <div className="customers-stars">
                                    <StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/>
                                </div>
                                <p className="customers-review-text">"{t("¡Excelente test!")}"</p>
                            </div>
                        </SwiperSlide>
                    
                        <SwiperSlide>
                            <div className="customers-review">
                                <p className="customers-review-name">Alex</p>
                                <div className="customers-stars">
                                    <StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarHalfIcon style={{fill: "#ffc04d"}}/>
                                </div>
                                <p className="customers-review-text">"{t("Worth every penny for the personalized guide.")}"</p>
                            </div>
                        </SwiperSlide>

                        <SwiperSlide>
                            <div className="customers-review">
                                <p className="customers-review-name">David R.</p>
                                <div className="customers-stars">
                                    <StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarHalfIcon style={{fill: "#ffc04d"}}/>
                                </div>
                                <p className="customers-review-text">"{t("Honestly, I was skeptical at first, but the test really nailed my personality. The 60% off coupon for the course was a massive bonus!")}"</p>
                            </div>
                        </SwiperSlide>

                        <SwiperSlide>
                            <div className="customers-review">
                                <p className="customers-review-name">Thomas B.</p>
                                <div className="customers-stars">
                                    <StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/>
                                </div>
                                <p className="customers-review-text">"{t("Sehr hilfreicher Test. Die Auswertung ist detailliert und gut verständlich.")}"</p>
                            </div>
                        </SwiperSlide>

                        <SwiperSlide>
                            <div className="customers-review">
                                <p className="customers-review-name">Emma</p>
                                <div className="customers-stars">
                                    <StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/>
                                </div>
                                <p className="customers-review-text">"{t("Spot on! Highly recommended.")}"</p>
                            </div>
                        </SwiperSlide>

                        <SwiperSlide>
                            <div className="customers-review">
                                <p className="customers-review-name">Ana P.</p>
                                <div className="customers-stars">
                                    <StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/>
                                </div>
                                <p className="customers-review-text">"{t("Muy preciso. Me ayudó a decidirme por el desarrollo web en lugar de diseño.")}"</p>
                            </div>
                        </SwiperSlide>

                        <SwiperSlide>
                            <div className="customers-review">
                                <p className="customers-review-name">Jessica T.</p>
                                <div className="customers-stars">
                                    <StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/>
                                </div>
                                <p className="customers-review-text">"{t("I wasn't sure if frontend or backend was for me. This cleared it up completely.")}"</p>
                            </div>
                        </SwiperSlide>

                        <SwiperSlide>
                            <div className="customers-review">
                                <p className="customers-review-name">Julia</p>
                                <div className="customers-stars">
                                    <StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/>
                                </div>
                                <p className="customers-review-text">"{t("Einfach klasse!")}"</p>
                            </div>
                        </SwiperSlide>

                        <SwiperSlide>
                            <div className="customers-review">
                                <p className="customers-review-name">Luis F.</p>
                                <div className="customers-stars">
                                    <StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarHalfIcon style={{fill: "#ffc04d"}}/>
                                </div>
                                <p className="customers-review-text">"{t("Vale la pena pagar por el reporte. La hoja de ruta es súper clara y me ahorró mucho tiempo buscando tutoriales al azar.")}"</p>
                            </div>
                        </SwiperSlide>

                        <SwiperSlide>
                            <div className="customers-review">
                                <p className="customers-review-name">Mark</p>
                                <div className="customers-stars">
                                    <StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/>
                                </div>
                                <p className="customers-review-text">"{t("Great test.")}"</p>
                            </div>
                        </SwiperSlide>

                        <SwiperSlide>
                            <div className="customers-review">
                                <p className="customers-review-name">Markus K.</p>
                                <div className="customers-stars">
                                    <StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarHalfIcon style={{fill: "#ffc04d"}}/>
                                </div>
                                <p className="customers-review-text">"{t("Ich wusste nicht, wo ich anfangen soll. Jetzt habe ich einen genauen Plan.")}"</p>
                            </div>
                        </SwiperSlide>

                        <SwiperSlide>
                            <div className="customers-review">
                                <p className="customers-review-name">Chris B.</p>
                                <div className="customers-stars">
                                    <StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/>
                                </div>
                                <p className="customers-review-text">"{t("Gave me the confidence to finally start learning to code.")}"</p>
                            </div>
                        </SwiperSlide>

                        <SwiperSlide>
                            <div className="customers-review">
                                <p className="customers-review-name">Sofia</p>
                                <div className="customers-stars">
                                    <StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/>
                                </div>
                                <p className="customers-review-text">"{t("Me encantó.")}"</p>
                            </div>
                        </SwiperSlide>

                        <SwiperSlide>
                            <div className="customers-review">
                                <p className="customers-review-name">Ryan M.</p>
                                <div className="customers-stars">
                                    <StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/>
                                </div>
                                <p className="customers-review-text">"{t("I was totally lost before this. The test is fun and the report is super detailed.")}"</p>
                            </div>
                        </SwiperSlide>

                        <SwiperSlide>
                            <div className="customers-review">
                                <p className="customers-review-name">Elena G.</p>
                                <div className="customers-stars">
                                    <StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/>
                                </div>
                                <p className="customers-review-text">"{t("¡Muy recomendable!")}"</p>
                            </div>
                        </SwiperSlide>

                        <SwiperSlide>
                            <div className="customers-review">
                                <p className="customers-review-name">Stefan M.</p>
                                <div className="customers-stars">
                                    <StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/>
                                </div>
                                <p className="customers-review-text">"{t("Ich habe schon viele Tests online gemacht, aber dieser hier war mit Abstand der beste. Der Rabattcode für den Kurs hat sich absolut gelohnt.")}"</p>
                            </div>
                        </SwiperSlide>

                        <SwiperSlide>
                            <div className="customers-review">
                                <p className="customers-review-name">Ben</p>
                                <div className="customers-stars">
                                    <StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarIcon style={{fill: "#ffc04d"}}/><StarHalfIcon style={{fill: "#ffc04d"}}/>
                                </div>
                                <p className="customers-review-text">"{t("Quick, accurate, and helpful.")}"</p>
                            </div>
                        </SwiperSlide>

                      
                    </Swiper>
                    </div>
                </div>
            </div>

       
    );
};

export default Summary;